import React from 'react';

// Auth route imports - COPIED EXACTLY from App.tsx
const Auth = React.lazy(() => import('@/pages/Auth'));
const VerifyEmail = React.lazy(() => import('@/pages/auth/VerifyEmail'));
const ResetPassword = React.lazy(() => import('@/pages/auth/ResetPassword'));
const EmailConfirmation = React.lazy(() => import('@/pages/auth/EmailConfirmation'));
const OAuthCallback = React.lazy(() => import('@/pages/auth/OAuthCallback'));

// Admin authentication (separate from customer auth)
const AdminLogin = React.lazy(() => import('@/pages/AdminLogin'));

// Authentication routes (no Layout wrapper needed - handled in parent)
export const authRoutes = [
  {
    path: 'auth',
    element: <Auth />,
  },
  {
    path: 'auth/verify-email',
    element: <VerifyEmail />,
  },
  {
    path: 'auth/reset-password',
    element: <ResetPassword />,
  },
  {
    path: 'auth/confirm',
    element: <EmailConfirmation />,
  },
  {
    path: 'auth/callback',
    element: <OAuthCallback />,
  },
  // Admin authentication (separate from customer auth)
  {
    path: 'admin/login',
    element: <AdminLogin />,
  },
  // REMOVED: V1 verification page
  // {
  //   path: 'auth/verify-quote',
  //   element: <VerifyQuoteApproval />,
  // },
];